// extracted by mini-css-extract-plugin
export var bubble = "_2w-0";
export var container = "_2w-3";
export var contrastBorder = "_2w-4";
export var greyOut = "_2w-2";
export var initialsWrapper = "_2w-1";
export var large = "_2w-9";
export var medium = "_2w-8";
export var mediumSmall = "_2w-7";
export var mediumSmallMedium = "_2w-c";
export var micro = "_2w-5";
export var small = "_2w-6";
export var tiny = "_2w-b";
export var xTiny = "_2w-a";